import { defineMessages } from 'react-intl';

export default defineMessages({
  delete: {
    id: 'delete',
    defaultMessage: 'Delete'
  },
  removeProjects: {
    id: 'removeProjects',
    defaultMessage: 'Remove selected projects'
  },
  confirmDelete: {
    id: 'confirmDelete',
    defaultMessage: 'Are you sure you want to delete the selected designs?'
  },
});
